import { jsx as _jsx } from "react/jsx-runtime";
import ReactApexChart from 'react-apexcharts';
import { merge } from '../generics/utils';
import { BaseOptionChart } from './BaseOptionChart';
const CHART_DATA = [{ name: 'Net Profit', data: [44, 55, 57, 56, 61, 58, 63, 60, 66] }];
export function ChartColumnSingle() {
    const chartOptions = merge(BaseOptionChart(), {
        plotOptions: { bar: { columnWidth: '14%', borderRadius: 4 } },
        stroke: { show: false },
        xaxis: {
            categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
        },
        tooltip: {
            y: {
                formatter: (val) => `$ ${val} thousands`,
            },
        },
    });
    return _jsx(ReactApexChart, { type: "bar", series: CHART_DATA, options: chartOptions, height: 320 }, void 0);
}
//# sourceMappingURL=ChartColumnSingle.js.map